import { Main } from '@sl/base/logic/slots/main';

export class Dropper extends Main { 
    constructor(scene) {
        super(scene);
        this.initialAnimationSpeed = 400;
        this.delayAfterSpin = 1000;
        this.delayAfterLostSpin = 1500;
        this.dropColumnDelay = 122.5;
        this.dropRowDelay = 37.5;
        this.dropInDelay = 500;
        this.initialSpinSpeed = 1;
        this.currentSpinSpeed = this.initialSpinSpeed;
    }

    moveReels(action) {
        if(this.spinStarted) {
            if(action === 'out') {
                this.scene.playSpinSound();
            }

            for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
                if(action === 'out') {
                    this.dropOutReel(parseInt(reelIndex), reel);
                } else {
                    this.dropInReel(parseInt(reelIndex), reel);
                }
            }
        }
    }

    dropOutReel(reelIndex, reel) {
        let symbolIndex = reel.offsetPosition + this.visibleRowsCount; 
        const reelLength = reel.symbols.length;

        if(symbolIndex > reelLength-1) {
            symbolIndex = symbolIndex - reelLength;
        }

        for(let i = 0; i < this.visibleRowsCount; i++) {
            if(symbolIndex > reelLength-1) {
                symbolIndex = reelLength - symbolIndex;
            }

            symbolIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex);
            
            let delay = (i * this.dropColumnDelay / this.currentSpinSpeed) + (this.dropRowDelay / this.currentSpinSpeed * reelIndex);
           
            const reel = this.reelsContainersObjects[reelIndex];
            const symbol = reel.symbols[symbolIndex];
            
            if(this.visibleCountByReel && this.visibleCountByReel[reelIndex] > symbol.positionOnReel) {
                symbol.alpha = 0;
            }

            this.moveSymbolOut(parseInt(reelIndex), symbolIndex, delay, 'out');

            if(Object.keys(this.reelsContainersObjects).length === reelIndex && i === (this.visibleRowsCount-1)) {
                this.scene.time.delayedCall(delay + this.dropInDelay / this.currentSpinSpeed, () => {this.moveReels('in');}, {}, this);
            }
        }
    }

    async dropInReel(reelIndex, reel) {
        let scenarioExists = Object.keys(this.scene.request.scenario).length;

        while(!scenarioExists) {
            await this.sleep(100);

            scenarioExists = Object.keys(this.scene.request.scenario).length;
        }

        this.reelsContainersObjects[reelIndex].offsetPosition = this.scene.request.scenario.reels[reelIndex];
        let symbolIndex = this.reelsContainersObjects[reelIndex].offsetPosition + this.visibleRowsCount;
        const reelLength = reel.symbols.length;

        if(symbolIndex > reelLength-1) {
            symbolIndex = symbolIndex - reelLength;
        }

        for(let i = 0; i < this.visibleRowsCount; i++) {
            if(symbolIndex > reelLength-1) {
                symbolIndex = reelLength - symbolIndex;
            }

            let delay = (i * this.dropColumnDelay / this.currentSpinSpeed) + (this.dropRowDelay / this.currentSpinSpeed * reelIndex);

            symbolIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex, delay);
            var position = (this.visibleRowsCount - 1 - i);

            const reel = this.reelsContainersObjects[reelIndex];
            const symbol = reel.symbols[symbolIndex];
            
            if(this.visibleCountByReel && (this.visibleRowsCount - this.visibleCountByReel[reelIndex]-1) < position) {
                symbol.alpha = 0;
            } else { 
                symbol.alpha = 1;
            }

            this.moveSymbolIn(reelIndex, symbolIndex, delay, position);
            
            if(Object.keys(this.reelsContainersObjects).length === reelIndex && i === (this.visibleRowsCount-1)) {
                delay = this.delayAfterSpin / this.currentSpinSpeed;

                if(!this.scene.request.scenario.amount_won) {
                    delay = this.delayAfterLostSpin / this.currentSpinSpeed;
                }

                this.scene.time.delayedCall(delay, () => {
                    this.spinStarted = false;
                    this.scene.request.spinStopped();
                    this.scene.afterSpin();
                }, {}, this);
            }
        }
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    moveSymbolOut(reelIndex, symbolIndex, delay) {
        const reel = this.reelsContainersObjects[reelIndex];
        const symbol = reel.symbols[symbolIndex];
        const destination = this.getSymbolCoordinateY(this.visibleRowsCount, symbol) + this.destinationOffset;

        this.scene.tweens.add({
            targets: symbol,
            y: destination,
            ease: 'Power0',
            delay: delay,
            duration: this.initialAnimationSpeed / this.currentSpinSpeed,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                symbol.positionOnReel = -1;
                symbol.alpha = 0;
            },
        });
    }

    moveSymbolIn(reelIndex, symbolIndex, delay, position) {
        const reel = this.reelsContainersObjects[reelIndex];
        const symbol = reel.symbols[symbolIndex];
        symbol.y = this.getSymbolCoordinateY(-1, symbol);
        const destination = this.getSymbolCoordinateY(position, symbol);

        this.scene.tweens.add({
            targets: symbol,
            y: destination,
            ease: 'Power0',
            delay: delay,
            duration: this.initialAnimationSpeed / this.currentSpinSpeed,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                symbol.positionOnReel = position;
            },
        });
    }

    createReels() {
        let offsetX = this.symbolsOffsetX();

        this.reelsContainer = this.scene.add.container();
        this.reelsContainer.x = this.scene.cameras.main.centerX;
        this.reelsContainer.y = 0;

        for (const [ reelIndex, reel ] of Object.entries(this.reels)) {
            this.reelsContainersObjects[reelIndex] = {'symbols':[]};

            this.reelsContainersObjects[reelIndex].spinned = 0;
            this.reelsContainersObjects[reelIndex].initialPositions = {};
            let positionOnReel = 0;
            this.reelsContainersObjects[reelIndex].reelStartsAt = 0;
            let appended = 0;

            for (const [ symbolIndex, symbol ] of Object.entries(reel)) {
                const symbolSprite = this.createSymbolSprite(reelIndex, reel, symbolIndex, symbol, appended);

                symbolSprite.positionOnReel = positionOnReel;
                symbolSprite.symbolKey = reel[symbolIndex];

                symbolSprite.y = this.getSymbolCoordinateY(positionOnReel, symbolSprite);
                symbolSprite.x = offsetX;
  
                this.reelsContainer.add(symbolSprite);
                this.reelsContainersObjects[reelIndex].symbols.push(symbolSprite);

                if(this.visibleRowsCount >= positionOnReel) {
                    if(!symbolSprite.appended) {
                        symbolSprite.alpha = 1;
                    }

                    if(positionOnReel > this.visibleRowsCount-1) {
                        symbolSprite.y += this.destinationOffset;
                    }

                    positionOnReel++;
                }
            }
            
            this.reelsContainersObjects[reelIndex].offsetPosition = 0;
            this.reelsContainersObjects[reelIndex].x = offsetX;
            //this.reelsContainersObjects[reelIndex].y = this.reelsOffsetTop;
            this.reelsContainersObjects[reelIndex].name = `reel_${reelIndex}`;
            //this.frameContainer.add(this.reelsContainersObjects[reelIndex]);
            //this.reelsContainer.add(this.reelsContainersObjects[reelIndex]);

            offsetX += this.spaceBetweenReels + this.symbolWidth;
        }

        this.createReelsMask();
    }

    prepareReels() {
        this.currentSpinSpeed = this.initialSpinSpeed;
        if(this.speed) {
            this.speedUpSpin();
        }
        
        this.moveReels('out');
    }

    speedUpSpin() {
        this.currentSpinSpeed = 2;
    }

    resetSpinSpeed() {
        this.currentSpinSpeed = 1;
    }
}